import React from 'react';

export default () => {
  return (
    <div className="step row">
      {/*Pregunta 21*/}
      <div className="col-md-12">
        <h3>21. ¿Siento entusiasmo y pasión por mi trabajo?</h3>
        <ul className="data-list-2" id="preg21">
          <li>
            <input
              name="preg21"
              type="radio"
              className="required check_radio"
              value="2"
            />
            <label>Totalmente De acuerdo</label>
          </li>
          <li>
            <input
              name="preg21"
              type="radio"
              className="required check_radio"
              value="1"
            />
            <label>De acuerdo</label>
          </li>
          <li>
            <input
              name="preg21"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Ni de acuerdo ni en desacuerdo</label>
          </li>
          <li>
            <input
              name="preg21"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>En desacuerdo</label>
          </li>
          <li>
            <input
              name="preg21"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Totalmente desacuerdo</label>
          </li>
        </ul>
      </div>
      {/*Pregunta 22*/}
      <div className="col-md-12">
        <h3>
          22. ¿Siento que el trabajo que realizo beneficia la vida de mis
          clientes o de mi entorno?
        </h3>
        <ul className="data-list-2" id="preg22">
          <li>
            <input
              name="preg22"
              type="radio"
              className="required check_radio"
              value="2"
            />
            <label>Totalmente De acuerdo</label>
          </li>
          <li>
            <input
              name="preg22"
              type="radio"
              className="required check_radio"
              value="1"
            />
            <label>De acuerdo</label>
          </li>
          <li>
            <input
              name="preg22"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Ni de acuerdo ni en desacuerdo</label>
          </li>
          <li>
            <input
              name="preg22"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>En desacuerdo</label>
          </li>
          <li>
            <input
              name="preg22"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Totalmente desacuerdo</label>
          </li>
        </ul>
      </div>
      {/*Pregunta 23*/}
      <div className="col-md-12">
        <h3>
          23. ¿El ambiente en mi empresa apoya un balance entre el trabajo y la
          vida personal?
        </h3>
        <ul className="data-list-2" id="preg23">
          <li>
            <input
              name="preg23"
              type="radio"
              className="required check_radio"
              value="2"
            />
            <label>Totalmente De acuerdo</label>
          </li>
          <li>
            <input
              name="preg23"
              type="radio"
              className="required check_radio"
              value="1"
            />
            <label>De acuerdo</label>
          </li>
          <li>
            <input
              name="preg23"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Ni de acuerdo ni en desacuerdo</label>
          </li>
          <li>
            <input
              name="preg23"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>En desacuerdo</label>
          </li>
          <li>
            <input
              name="preg23"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Totalmente desacuerdo</label>
          </li>
        </ul>
      </div>
      {/*Pregunta 24*/}
      <div className="col-md-12">
        <h3>
          24. ¿Dispongo del tiempo necesario en mi horario normal de labor para
          realizar mi trabajo?
        </h3>
        <ul className="data-list-2" id="preg24">
          <li>
            <input
              name="preg24"
              type="radio"
              className="required check_radio"
              value="2"
            />
            <label>Totalmente De acuerdo</label>
          </li>
          <li>
            <input
              name="preg24"
              type="radio"
              className="required check_radio"
              value="1"
            />
            <label>De acuerdo</label>
          </li>
          <li>
            <input
              name="preg24"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Ni de acuerdo ni en desacuerdo</label>
          </li>
          <li>
            <input
              name="preg24"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>En desacuerdo</label>
          </li>
          <li>
            <input
              name="preg24"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Totalmente desacuerdo</label>
          </li>
        </ul>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/survey/questions/Step6.jsx